import { createAction } from 'redux-actions';
import * as types from './types';
import firebase from 'firebase/app';
import 'firebase/database';
import { episodeActionPayloadTransformer } from '../managers/episode';

export function handleContentSaving(id, saved) {
  return {
    type: types.CONTENT_SAVED,
    payload: { [id]: true },
  };
}

export function addDefaultSoundcast() {
  return {
    type: types.DEFAULT_SOUNDCAST_ADDED,
    payload: true,
  };
}

export function signupUser(user) {
  return {
    type: types.SIGNUP,
    payload: user,
  };
}

export function signinUser(user) {
  return {
    type: types.SIGNIN,
    payload: user,
  };
}

export function sendEmail() {
  return {
    type: types.EMAIL_SENT,
    payload: true,
  };
}

export function signoutUser(autoredirect = true) {
  return dispatch => {
    if (GoogleAuth) {
      // ??? GoogleAuth can be determined, but sign in not used
      GoogleAuth.signOut().then(() => autoredirect && window.location.replace('/signin'));
    } else {
      window.signinReload = true;
    }

    // make sure to clear out localStorage too
    // used from signup
    if (localStorage.length > 0) {
      localStorage.clear();
    }

    //We don't have to wait for google to sign out, lets dispatch the action
    //right away.
    dispatch({
      type: types.SIGNOUT,
    });
  };
}

export function loadCourses(courses) {
  return {
    type: types.COURSES,
    payload: courses,
  };
}

export function loadUserCourses(courses) {
  return {
    type: types.USER_COURSES,
    payload: courses,
  };
}

export function launchPlayer(status) {
  return {
    type: types.PLAYER,
    payload: status,
  };
}

export function setCurrentPlaylist(playlist) {
  return {
    type: types.PLAYLIST,
    payload: playlist,
  };
}

export function setCurrentPlaySection(section) {
  return {
    type: types.CURRENT_SECTION,
    payload: section,
  };
}

export function getCurrentProgress(progress) {
  return {
    type: types.CURRENT_PROGRESS,
    payload: progress,
  };
}

export function changePlayStatus(status) {
  return {
    type: types.CHANGE_PLAYSTATUS,
    payload: status,
  };
}

export function openSignupbox(open) {
  return {
    type: (open === true && types.OPEN_SIGNUPBOX) || (open === false && types.CLOSE_SIGNUPBOX),
  };
}

export function openConfirmationbox(open) {
  return {
    type: (open && types.OPEN_CONFIRMATIONBOX) || types.CLOSE_CONFIRMATIONBOX,
  };
}

export function setCurrentCourse(course) {
  return {
    type: types.CURRENT_COURSE,
    payload: course,
  };
}

export function openReviewbox(open) {
  return { type: (open && types.OPEN_REVIEWBOX) || types.CLOSE_REVIEWBOX };
}

export function addCourseToCart(course) {
  return {
    type: types.ADDTOCART,
    payload: course,
  };
}

export function deleteCourseFromCart(course) {
  return {
    type: types.DELETE_FROM_CART,
    payload: course,
  };
}

export function deleteCart() {
  return {
    type: types.DELETE_ALL,
  };
}

export function changeSpeed(value) {
  return {
    type: types.CHANGE_SPEED,
    payload: value,
  };
}

export function subscribeToCategories() {
  return dispatch => {
    firebase
      .database()
      .ref('categories')
      .on('value', snapshot => {
        let _categories = snapshot.val();
        dispatch({
          type: types.SUBSCRIBE_TO_CATEGORIES,
          payload: _categories,
        });
      });
  };
}

// v2 Action Creators

// Order soundcasts, bundles, soundcasts in bundle
export const changeSoundcastsOrder = createAction(types.CHANGE_SOUNDCASTS_ORDER);
export const changeBundlesOrder = createAction(types.CHANGE_BUNDLES_ORDER);
export const changeBundleSoundcastsOrder = createAction(types.CHANGE_BUNDLE_SOUNDCASTS_ORDER);

// User
export const openUserChannel = createAction(types.OPEN_USER_CHANNEL);
export const closeUserChannel = createAction(types.CLOSE_USER_CHANNEL);
export const updateUser = createAction(types.UPDATE_USER);
export const updateUserManaged = createAction(types.UPDATE_USER_MANAGED);

// Publisher
export const openPublisherChannel = createAction(types.OPEN_PUBLISHER_CHANNEL);
export const closePublisherChannel = createAction(types.CLOSE_PUBLISHER_CHANNEL);
export const updatePublisher = createAction(types.UPDATE_PUBLISHER);

// Managed Soundcast
export const openSoundcastChannel = createAction(types.OPEN_SOUNDCAST_CHANNEL);
export const closeSoundcastChannel = createAction(types.CLOSE_SOUNDCAST_CHANNEL);
export const selectSoundcast = createAction(types.SELECT_SOUNDCAST);
export const receiveManagedSoundcasts = createAction(types.RECEIVE_MANAGED_SOUNDCASTS);
export const updateManagedSoundcast = createAction(types.UPDATE_MANAGED_SOUNDCAST);
export const updateManagedSoundcastsStatus = createAction(types.MANAGED_SOUNDCASTS_STATUS);
export const increasePlanCurrentUsage = createAction(types.INCREASE_PLAN_CURRENT_USAGE);
export const decreasePlanCurrentUsage = createAction(types.DECREASE_PLAN_CURRENT_USAGE);
export const removeSoundcastPendingInvites = createAction(types.REMOVE_SOUNDCAST_PENDING_INVITES);

// Managed Episodes
export const receiveManagedSoundcastEpisodes = createAction(
  types.RECEIVE_MANAGED_SOUNDCAST_EPISODES
);

export const addUpdateManagedSoundcastEpisode = createAction(
  types.ADD_UPDATE_MANAGED_SOUNDCAST_EPISODE,
  episodeActionPayloadTransformer
);

// Publisher Categories
export const createPublisherCategory = createAction(types.CREATE_PUBLISHER_CATEGORY);
export const fetchCategories = createAction(types.FETCH_PUBLISHER_CATEGORIES);
export const loadCategories = createAction(types.LOAD_PUBLISHER_CATEGORIES);
export const fetchPublisherCategoryInfo = createAction(types.FETCH_PUBLISHER_CATEGORY_INFO);
export const loadPublisherCategoryInfo = createAction(types.LOAD_PUBLISHER_CATEGORY_INFO);
export const updateSoundcastsPublisherCategory = createAction(
  types.UPDATE_SOUNDCAST_PUBLISHER_CATEGORY
);
export const updateSoundcastsCategoryTitle = createAction(
  types.UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE
);
export const updatePublisherCategoryOrder = createAction(types.UPDATE_PUBLISHER_CATEGORIES_ORDER);
export const deletePublisherCategory = createAction(types.DELETE_PUBLISHER_CATEGORY);
